<template>
  <div class="animated fadeIn">
    <div class="container" style="min-width: 1800px;">
      <clientselection
        v-if="isMSMUser || hasDashboardCustomerSelection()"
        v-on:clientselectionchanged="onClientSelectionChanged"
      />

      <div class="row">
        <div class="col-xl">
          <div ref="cockpit" v-bind:class="{ spinner: isLoading }">
            <div class="col-md-auto excelButtonTooltip" >

              <b-button v-if="hasFileImport && localUserProfile.Permissions.includes('Import')"
                        id="importButton" size="sm" variant="primary" to="cx/importmarginfile"
                        class="app-ctrl">
                <font-awesome-icon icon="file-import" /> {{ $t('Webportal.Import') }}
              </b-button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import CancelToken from "@/mixins/CancelToken";
import i18n from '@/i18n';

import EventBus from "@/services/EventBus.js";
import AuthenticationService from "@/services/AuthenticationService";
import DashboardService from "@/services/DashboardService";
import AdministrationService from "@/services/AdministrationService";
import ReportsService from '@/services/ReportsService';

import clientselection from "./ClientSelection";

export default {
  mixins: [AppConfig, CancelToken ],

  components: {
    clientselection,
  },

  created() {
    if (!this.isMSMUser) {
      this.ClientSelected = AuthenticationService.localUserProfile.ClientId;
      this.getClientSettings();
    }
  },

  data() {
    return {
      ColorRange: null,
      ClientSelected: null,

      isLoadingExport: false,
      isLoadingFilter: false,
      isLoadingSettings: false,
      isLoadingCountries: false,
      isLoadingDealer: false,
      isLoadingRetailer: false,

      optionsCancelToken: null,
      toolTipDelay: { delay: { show: 500, hide: 100 } },

      FallbackColorRange: [
        {
          Minimum: 0,
          Maximum: 69.99,
          Color: "#f54052",
          Smiley: 'frown-open'
        },
        {
          Minimum: 70,
          Maximum: 89.99,
          Color: "#FFD700",
          Smiley: 'meh'
        },
        {
          Minimum: 90,
          Maximum: 100,
          Color: "#36c259",
          Smiley: 'grin'
        }
      ]
    };
  },

  methods: {
    // ***********************************************************
    // HTML Events
    // ***********************************************************

    // Client Selection (for MSMUser)
    // ******************************
    onClientSelectionChanged(clientSettings) {
      if (clientSettings) {
        this.ClientSelected = clientSettings?.ClientId || null;
      }

      this.setClientSettings(clientSettings);
    },

    // ***********************************************************
    // Private methods
    // ***********************************************************
    getClientSettings(clientId) {
      return AdministrationService.getClientSettings(clientId || this.ClientSelected)
        .then(response => this.setClientSettings(response?.data?.[0]));
    },

    setClientSettings(clientSettings) {
      if (!clientSettings) return;

      this.ColorRange = clientSettings.Thresholds;
      this.DefaultLogo = clientSettings.LogoExternalImageId
        ? process.env.BASE_URL + `api/media/image?id=${clientSettings.LogoExternalImageId}`
        : process.env.BASE_URL + "static/img/msm_loop_logo_40px.png";
    }
  },

  computed: {
    isMSMUser: function() {
      return AuthenticationService.isMSMUser;
    },

    localUserProfile: function () {
      return AuthenticationService.localUserProfile;
    },

    hasFileImport() {
      return APP_TARGET === "jlr";
    },

    isLoading: function() {
      return (
        this.isLoadingSettings ||
        this.isLoadingFilter ||
        this.isLoadingCountries ||
        this.isLoadingDealer ||
        this.isLoadingRetailer ||
        this.isLoadingExport
      );
    }
  }
};
</script>

<style scoped>
.container {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
  width: 100%;
  min-width: 1366px;
}

.card {
  margin-bottom: 20px;
  word-wrap: unset;
}

.card-body {
  min-height: 150px;
}

.excelButton {
  background-color: #107c41;
  border-color: #107c41;
}

.excelButtonTooltip {
  z-index: 1;
  float: right;
  position: relative;
  bottom: -10px;
  right: 3px;
  margin-bottom: -50px;
}

b-dropdown.exportGroup > * {
  background-color: #107c41!important;
  color: #eee!important;
}

.tooltip {
  /* Workaround: https://github.com/bootstrap-vue/bootstrap-vue/issues/1732 */
  top: 0;
}

.b-tabs .nav {
  display: flex;
  align-items: center;
}
.b-tabs .ms-auto {
  margin-left: auto;
}

</style>

<style>
.disabledTab {
  pointer-events: none;
}

.disabledTab > .nav-link {
  pointer-events: none;
  display: none;
  color: rgba(255, 255, 255, 0) !important;
  cursor: not-allowed;
}
</style>
